module.exports = {
	"id": "GG",
	"name": "Guernsey",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.005945,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01189,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.01189,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01189,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.01189,
			"34": null,
			"35": 0.01189,
			"36": 0.005945,
			"37": null,
			"38": 0.065395,
			"39": null,
			"40": 0.029725,
			"41": 0.01189,
			"42": null,
			"43": 0.03567,
			"44": 0.041615,
			"45": 0.041615,
			"46": 0.01189,
			"47": 0.005945,
			"48": 0.07134,
			"49": 1.39113,
			"50": 0.07134,
			"51": 0.15457,
			"52": 0.303195,
			"53": 18.98833,
			"54": 5.05325,
			"55": 0.03567,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.02378,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.02378,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.017835,
			"20": 0.017835,
			"21": 0.315085,
			"22": null,
			"23": null,
			"24": 0.01189,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.05945,
			"31": 0.04756,
			"32": 0.03567,
			"33": null,
			"34": 0.017835,
			"35": 0.017835,
			"36": null,
			"37": 0.029725,
			"38": 0.01189,
			"39": null,
			"40": 0.01189,
			"41": null,
			"42": 0.01189,
			"43": 0.01189,
			"44": 0.005945,
			"45": 0.255635,
			"46": 0.029725,
			"47": 0.36859,
			"48": 0.433985,
			"49": 5.522905,
			"50": 0.02378,
			"51": 0.005945,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": 0.005945,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.19024,
			"41": 0.017835,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.02378,
			"5": 0.08323,
			"6": 0.005945,
			"7": 0.136735,
			"8": 0.469655,
			"9": 0.695565,
			"10": 4.31607,
			"3.1": null,
			"3.2": 0.017835,
			"5.1": 0.20213,
			"6.1": 0.15457,
			"7.1": 0.017835,
			"9.1": 2.74659
		},
		"ios_saf": {
			"8": 0,
			"10": 17.4884586969,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.471293725541,
			"8.1-8.4": 0.870695187864,
			"9.0-9.2": 0.415377520816,
			"9.3": 6.33716986886
		},
		"android": {
			"3": 0,
			"4": 0.0178231395349,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00222789244186,
			"4.1": 0.0642906104651,
			"4.2-4.3": 0.160726526163,
			"4.4": 0.368557063953,
			"4.4.3-4.4.4": 0.371739767442
		},
		"ie": {
			"6": 0.005945,
			"7": 0.03567,
			"8": 0.243745,
			"9": 0.36859,
			"10": 0.22591,
			"11": 10.47509,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00643180110773,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000178661141881
		},
		"edge": {
			"12": 0.124845,
			"13": 0.78474,
			"14": 3.37676
		},
		"ie_mob": {
			"10": 0.143923943662,
			"11": 0.585976056338
		},
		"bb": {
			"7": 0.00811,
			"10": null
		},
		"samsung": {
			"0": 4.3794
		},
		"and_uc": {
			"0": 0.04866
		},
		"op_mini": {
			"0": 0.0866545377504
		},
		"and_chr": {
			"0": 8.743745
		},
		"and_ff": {
			"0": 0.02433
		}
	},
	"total": 99.017285
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GG.json
 ** module id = 529
 ** module chunks = 0
 **/